import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { EmbeddedLink } from "../../ui/EmbeddedLink";
import { Medium } from "../../ui/Typography/Span";
export var LinkFormatting = function(linkTo, options) {
    return function LinkFormatting(chunks) {
        return /*#__PURE__*/ _jsx(EmbeddedLink, _object_spread_props(_object_spread({
            linkTo: linkTo
        }, options), {
            children: chunks
        }));
    };
};
export var ClickableFormatting = function(onClick, options) {
    return function ClickableFormatting(chunks) {
        return /*#__PURE__*/ _jsx(EmbeddedLink, _object_spread_props(_object_spread({
            onClick: onClick
        }, options), {
            children: chunks
        }));
    };
};
export var MediumFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Medium, {
        children: chunks
    });
};
